import React from "react"
import Rgpd from "gatsby-theme-blank/src/pages/rgpd"

const RgpdCactus = () => <Rgpd arianeDisplayed={true} />

export default RgpdCactus
